import { Button, Drawer, Text, useDrawer } from "../../design"
import { translate } from "../../utils/translations";
import ChooseSubscriptionToAddProduct from "./choose-subscription-to-add-product";
import CreateNewSubscriptionV2 from "./create-new-subscription-v2";

export default function ChoseAddSubscriptionProductMethod(props: any) {
    const drawers = useDrawer();
    const openExistingSubDrawer = () => {
        if (props.data.contracts.length) {
            drawers.open({
                component: ChooseSubscriptionToAddProduct,
                props: {
                    availableContacts: props.data.contracts,
                    selectedVariant: props.selectedVariant,
                    quantity: props.quantity,
                    selectedSellingPlan: props.selectedSellingPlan,
                    availableShippingAddress: props.availableShippingAddress,
                    reloadContracts: props.reloadContracts,
                },
            });
        } else {
            handleCreateNewSub();
        }
    }

    const handleCreateNewSub = () => {
        drawers.open({
            component: CreateNewSubscriptionV2,
            props: {
                availableContacts: props.data.contracts,
                selectedVariant: props.selectedVariant,
                quantity: props.quantity,
                selectedSellingPlan: props.selectedSellingPlan,
                availableShippingAddress: props.availableShippingAddress,
                reloadContracts: props.reloadContracts,
            },
        });
    }

    return <Drawer
        title={translate("choose_add_product_subscription_drawer_header")}
        active={props.active}
        toggleActive={props.toggleActive}
        id="choose-add-product-subscription-drawer"
    >
        <Drawer.Body>
            <div
                className="loop-cp-chose_existing_subscription_text"
                dangerouslySetInnerHTML={{
                    __html: translate(
                        "chose_existing_subscription_body_text",
                        {
                            matching_subscription_count: props.data.contracts.length
                        }
                    ),
                }}
            ></div>
            <div className="d-flex flex-column mt-5">
                <Button
                    size="lg"
                    className="m-2"
                    onClick={openExistingSubDrawer}
                >
                    {translate("add_to_existing_subscription_btn")}
                </Button>
                <Button
                    size="lg"
                    variant="outline"
                    className="m-2"
                    onClick={handleCreateNewSub}
                    id="loop-create-subscription-button"
                >
                    {translate("add_to_new_subscription_btn")}
                </Button>
            </div>
        </Drawer.Body>
        <Drawer.Footer>
            <div className="d-flex flex-column">
                <Button
                    size="lg"
                    variant="underline"
                    className="m-2"
                    onClick={props.toggleActive}
                >
                    {translate("go_back_button")}
                </Button>
            </div>
        </Drawer.Footer>
    </Drawer>
}